
import { getAdminToken } from './authService';

// Default pricing configuration
const defaultPricingConfig = {
  version: '1.0.0',
  lastUpdated: new Date().toISOString(),
  cableBasePrices: {
    audio: 1.25,
    power: 1.55,
    hybrid: 2.00,
    dmx: 1.25
  },
  powerWireGaugePricing: {
    '12AWG': 2.25,
    '14AWG': 1.55,
    '16AWG': 1.25
  },
  wyeCablePricing: {
    'audio': 1.75,
    'power': 2.25,
    'data': 2.50
  },
  panelMountPricing: {
    // XLR 3-pin connectors
    'NC3FXX': { partCost: 3.50, laborCost: 2.50 },
    'NC3MXX': { partCost: 3.50, laborCost: 2.50 },
    'NC3FRX': { partCost: 4.25, laborCost: 2.50 },
    'NC3MRX': { partCost: 4.25, laborCost: 2.50 },
    'NC3FD-L-1': { partCost: 4.50, laborCost: 2.50 },
    'NC3MD-L-1': { partCost: 4.50, laborCost: 2.50 },
    'SC3F': { partCost: 3.25, laborCost: 2.50 },
    'SC3M': { partCost: 3.25, laborCost: 2.50 },
    'AC3F': { partCost: 3.00, laborCost: 2.50 },
    'AC3M': { partCost: 3.00, laborCost: 2.50 },
    'GEN-XLR-F': { partCost: 2.50, laborCost: 2.50 },
    'GEN-XLR-M': { partCost: 2.50, laborCost: 2.50 },
    
    // XLR 5-pin connectors
    'NC5FXX': { partCost: 4.25, laborCost: 2.50 },
    'NC5MXX': { partCost: 4.25, laborCost: 2.50 },
    'SC5F': { partCost: 4.00, laborCost: 2.50 },
    'SC5M': { partCost: 4.00, laborCost: 2.50 },
    
    // 1/4" connectors
    '2T_M': { partCost: 2.75, laborCost: 2.50 },
    '2T_F': { partCost: 2.75, laborCost: 2.50 },
    '2TR_M': { partCost: 3.00, laborCost: 2.50 },
    '2TR_F': { partCost: 3.00, laborCost: 2.50 },
    '2T_M_RA': { partCost: 3.25, laborCost: 2.50 },
    '2T_F_RA': { partCost: 3.25, laborCost: 2.50 },
    '2TR_M_RA': { partCost: 3.50, laborCost: 2.50 },
    '2TR_F_RA': { partCost: 3.50, laborCost: 2.50 },
    '2T_M_PM': { partCost: 3.50, laborCost: 2.50 },
    '2T_F_PM': { partCost: 3.50, laborCost: 2.50 },
    '2TR_M_PM': { partCost: 3.75, laborCost: 2.50 },
    '2TR_F_PM': { partCost: 3.75, laborCost: 2.50 },
    'NP3X': { partCost: 3.25, laborCost: 2.50 },
    'NP2X': { partCost: 3.00, laborCost: 2.50 },
    'SC1/4TRS': { partCost: 3.00, laborCost: 2.50 },
    'SC1/4TS': { partCost: 2.75, laborCost: 2.50 },
    'AMP1/4TRS': { partCost: 2.75, laborCost: 2.50 },
    'AMP1/4TS': { partCost: 2.50, laborCost: 2.50 },
    'GEN-TRS-M': { partCost: 2.25, laborCost: 2.50 },
    'GEN-TS-M': { partCost: 2.00, laborCost: 2.50 },
    
    // 3.5mm connectors
    '3T_M': { partCost: 2.25, laborCost: 2.50 },
    '3T_F': { partCost: 2.25, laborCost: 2.50 },
    '3TR_M': { partCost: 2.50, laborCost: 2.50 },
    '3TR_F': { partCost: 2.50, laborCost: 2.50 },
    '3T_M_RA': { partCost: 2.75, laborCost: 2.50 },
    '3T_F_RA': { partCost: 2.75, laborCost: 2.50 },
    '3TR_M_PM': { partCost: 3.00, laborCost: 2.50 },
    '3TR_F_PM': { partCost: 3.00, laborCost: 2.50 },
    
    // RCA connectors
    'RCA_M': { partCost: 2.50, laborCost: 2.50 },
    'RCA_F': { partCost: 2.50, laborCost: 2.50 },
    'RCA_M_RA': { partCost: 2.75, laborCost: 2.50 },
    'RCA_F_RA': { partCost: 2.75, laborCost: 2.50 },
    'RCA_M_PM': { partCost: 3.00, laborCost: 2.50 },
    'RCA_F_PM': { partCost: 3.00, laborCost: 2.50 },
    'NYS352': { partCost: 2.75, laborCost: 2.50 },
    'GEN-RCA-M': { partCost: 2.00, laborCost: 2.50 },
    
    // Speakon connectors
    'NL2MX': { partCost: 4.50, laborCost: 2.50 },
    'NL4FX': { partCost: 5.25, laborCost: 2.50 },
    'NL4MX': { partCost: 5.25, laborCost: 2.50 },
    'NL8FC': { partCost: 6.50, laborCost: 2.50 },
    'NL8MX': { partCost: 6.50, laborCost: 2.50 },
    'SPK2_M_PM': { partCost: 5.00, laborCost: 2.50 },
    'SPK4_M_PM': { partCost: 5.75, laborCost: 2.50 },
    'SPK8_M_PM': { partCost: 7.00, laborCost: 2.50 },
    'SPK8_M_PM_BAG': { partCost: 7.50, laborCost: 2.50 },
    'NL2FX': { partCost: 4.50, laborCost: 2.50 },
    'NL4FX': { partCost: 5.25, laborCost: 2.50 },
    'NL8FC': { partCost: 6.50, laborCost: 2.50 },
    'GEN-SPEAKON-F': { partCost: 3.50, laborCost: 2.50 },
    
    // Power connectors
    'NEMA_5-15P_cable_mount_male': { partCost: 3.75, laborCost: 2.50 },
    'NEMA_5-15P_panel_mount_male': { partCost: 4.25, laborCost: 2.50 },
    'NEMA_5-15R_cable_mount_female': { partCost: 3.75, laborCost: 2.50 },
    'NEMA_5-15R_panel_mount_female': { partCost: 4.25, laborCost: 2.50 },
    'NEMA5-15P': { partCost: 3.50, laborCost: 2.50 },
    'NEMA5-15R': { partCost: 3.50, laborCost: 2.50 },
    
    'IEC_C14_cable_mount_male': { partCost: 4.00, laborCost: 2.50 },
    'IEC_C14_panel_mount_male': { partCost: 4.50, laborCost: 2.50 },
    'IEC_C13_cable_mount_female': { partCost: 4.00, laborCost: 2.50 },
    'IEC_C13_panel_mount_female': { partCost: 4.50, laborCost: 2.50 },
    
    // PowerCON Panel Mount Connectors
    'NAC3MPXXA': { partCost: 12.50, laborCost: 2.50 },
    'NAC3MPXXB': { partCost: 12.50, laborCost: 2.50 },
    'NAC3MP-HC': { partCost: 15.75, laborCost: 2.50 },
    'NAC3MM-1': { partCost: 8.25, laborCost: 2.50 },
    // TRUE1 Panel Mount Connectors
    'NAC3MPX-TOP': { partCost: 18.50, laborCost: 2.50 },
    'NAC3FPX-TOP': { partCost: 18.50, laborCost: 2.50 },
    // UI Connector Names for PowerCON
    'NAC3MPXXA': { partCost: 12.50, laborCost: 2.50 },
    'NAC3MPXXB': { partCost: 12.50, laborCost: 2.50 },
    'IEC-C13': { partCost: 3.75, laborCost: 2.50 },
    'IEC-C14': { partCost: 3.75, laborCost: 2.50 },
    
    'NAC3FXXA-W-S': { partCost: 10.25, laborCost: 1.8 },
    'PowerCon_Grey_cable_mount_male': { partCost: 10.25, laborCost: 1.8 },
    'PowerCon_Grey_panel_mount_female': { partCost: 12.50, laborCost: 2.0 },
    'NAC3FCA': { partCost: 5.25, laborCost: 2.00 },
    'NAC3FCB': { partCost: 5.25, laborCost: 2.00 },
    'NAC3M-TRUE1-S': { partCost: 5.50, laborCost: 2.00 },
    'NAC3F-TRUE1-S': { partCost: 5.25, laborCost: 2.00 },
    
    // DMX connectors
    'XLR3_F_DMX': { partCost: 3.50, laborCost: 1.50 },
    'XLR3_F_DMX_RA': { partCost: 4.25, laborCost: 1.75 },
    'XLR3_F_DMX_PANEL': { partCost: 4.50, laborCost: 2.00 },
    'XLR3_M_DMX': { partCost: 3.50, laborCost: 1.50 },
    'XLR3_M_DMX_RA': { partCost: 4.25, laborCost: 1.75 },
    'XLR3_M_DMX_PANEL': { partCost: 4.50, laborCost: 2.00 },
    'XLR5_F_DMX': { partCost: 4.25, laborCost: 1.75 },
    'XLR5_F_DMX_RA': { partCost: 5.00, laborCost: 2.00 },
    'XLR5_F_DMX_PANEL': { partCost: 5.25, laborCost: 2.25 },
    'XLR5_M_DMX': { partCost: 4.25, laborCost: 1.75 },
    'XLR5_M_DMX_RA': { partCost: 5.00, laborCost: 2.00 },
    'XLR5_M_DMX_PANEL': { partCost: 5.25, laborCost: 2.25 },
    
    // Other connectors
    'RJ45': { partCost: 2.50, laborCost: 2.50 },
    'NE8MX6': { partCost: 4.50, laborCost: 2.50 },
    'GEN-RJ45-M': { partCost: 2.00, laborCost: 2.50 },
    'BNC': { partCost: 3.25, laborCost: 2.50 },
    'BNC-RA': { partCost: 3.75, laborCost: 2.50 },
    'GEN-BNC-M': { partCost: 2.50, laborCost: 2.50 },
    'HDMI-A': { partCost: 3.00, laborCost: 2.50 },
    'HDMI-B': { partCost: 3.50, laborCost: 2.50 },
    'HDMI-C': { partCost: 3.25, laborCost: 2.50 },
    'USB-A': { partCost: 2.25, laborCost: 2.50 },
    'USB-B': { partCost: 2.50, laborCost: 2.50 },
    'USB-C': { partCost: 2.75, laborCost: 2.50 }
  },
  inlinePricing: {
    // XLR 3-pin connectors
    'NC3FXX': { partCost: 2.75, laborCost: 2.50 },
    'NC3MXX': { partCost: 2.75, laborCost: 2.50 },
    'NC3FRX': { partCost: 3.50, laborCost: 2.50 },
    'NC3MRX': { partCost: 3.50, laborCost: 2.50 },
    'NC3FD-L-1': { partCost: 3.75, laborCost: 2.50 },
    'NC3MD-L-1': { partCost: 3.75, laborCost: 2.50 },
    'SC3F': { partCost: 2.50, laborCost: 2.50 },
    'SC3M': { partCost: 2.50, laborCost: 2.50 },
    'AC3F': { partCost: 2.25, laborCost: 2.50 },
    'AC3M': { partCost: 2.25, laborCost: 2.50 },
    'GEN-XLR-F': { partCost: 1.75, laborCost: 2.50 },
    'GEN-XLR-M': { partCost: 1.75, laborCost: 2.50 },
    
    // XLR 5-pin connectors
    'NC5FXX': { partCost: 3.50, laborCost: 2.50 },
    'NC5MXX': { partCost: 3.50, laborCost: 2.50 },
    'SC5F': { partCost: 3.25, laborCost: 2.50 },
    'SC5M': { partCost: 3.25, laborCost: 2.50 },
    
    // 1/4" connectors
    '2T_M': { partCost: 2.25, laborCost: 2.50 },
    '2T_F': { partCost: 2.25, laborCost: 2.50 },
    '2TR_M': { partCost: 2.50, laborCost: 2.50 },
    '2TR_F': { partCost: 2.50, laborCost: 2.50 },
    '2T_M_RA': { partCost: 2.75, laborCost: 2.50 },
    '2T_F_RA': { partCost: 2.75, laborCost: 2.50 },
    '2TR_M_RA': { partCost: 3.00, laborCost: 2.50 },
    '2TR_F_RA': { partCost: 3.00, laborCost: 2.50 },
    '2T_M_PM': { partCost: 3.00, laborCost: 2.50 },
    '2T_F_PM': { partCost: 3.00, laborCost: 2.50 },
    '2TR_M_PM': { partCost: 3.25, laborCost: 2.50 },
    '2TR_F_PM': { partCost: 3.25, laborCost: 2.50 },
    'NP3X': { partCost: 2.75, laborCost: 2.50 },
    'NP2X': { partCost: 2.50, laborCost: 2.50 },
    'SC1/4TRS': { partCost: 2.50, laborCost: 2.50 },
    'SC1/4TS': { partCost: 2.25, laborCost: 2.50 },
    'AMP1/4TRS': { partCost: 2.25, laborCost: 2.50 },
    'AMP1/4TS': { partCost: 2.00, laborCost: 2.50 },
    'GEN-TRS-M': { partCost: 1.75, laborCost: 2.50 },
    'GEN-TS-M': { partCost: 1.50, laborCost: 2.50 },
    
    // 3.5mm connectors
    '3T_M': { partCost: 1.75, laborCost: 2.50 },
    '3T_F': { partCost: 1.75, laborCost: 2.50 },
    '3TR_M': { partCost: 2.00, laborCost: 2.50 },
    '3TR_F': { partCost: 2.00, laborCost: 2.50 },
    
    // RCA connectors
    'RCA_M': { partCost: 2.00, laborCost: 2.50 },
    'RCA_F': { partCost: 2.00, laborCost: 2.50 },
    'RCA_M_RA': { partCost: 2.25, laborCost: 2.50 },
    'RCA_F_RA': { partCost: 2.25, laborCost: 2.50 },
    'RCA_M_PM': { partCost: 2.50, laborCost: 2.50 },
    'RCA_F_PM': { partCost: 2.50, laborCost: 2.50 },
    'NYS352': { partCost: 2.25, laborCost: 2.50 },
    'GEN-RCA-M': { partCost: 1.50, laborCost: 2.50 },
    
    // Speakon connectors
    'NL2MX': { partCost: 3.75, laborCost: 2.50 },
    'NL2MX': { partCost: 3.75, laborCost: 2.50 },
    'NL4FX': { partCost: 4.25, laborCost: 2.50 },
    'NL4MX': { partCost: 4.25, laborCost: 2.50 },
    'NL8FC': { partCost: 5.50, laborCost: 2.50 },
    'NL8MX': { partCost: 5.50, laborCost: 2.50 },
    'SPK2_M_PM': { partCost: 4.25, laborCost: 2.50 },
    'SPK4_M_PM': { partCost: 4.75, laborCost: 2.50 },
    'SPK8_M_PM': { partCost: 6.00, laborCost: 2.50 },
    'SPK8_M_PM_BAG': { partCost: 6.50, laborCost: 2.50 },
    'NL2FX': { partCost: 3.75, laborCost: 2.50 },
    'NL4FX': { partCost: 4.25, laborCost: 2.50 },
    'NL8FC': { partCost: 5.50, laborCost: 2.50 },
    'GEN-SPEAKON-F': { partCost: 2.75, laborCost: 2.50 },
    
    // Power connectors
    'NEMA_5-15P_cable_mount_male': { partCost: 3.00, laborCost: 2.50 },
    'NEMA_5-15P_panel_mount_male': { partCost: 3.50, laborCost: 2.50 },
    'NEMA_5-15R_panel_mount_female': { partCost: 3.00, laborCost: 2.50 },
    'NEMA_5-15R_panel_mount_female': { partCost: 3.50, laborCost: 2.50 },
    'NEMA5-15P': { partCost: 2.75, laborCost: 2.50 },
    'NEMA5-15R': { partCost: 2.75, laborCost: 2.50 },
    
    'IEC_C14_cable_mount_male': { partCost: 3.25, laborCost: 2.50 },
    'IEC_C14_panel_mount_male': { partCost: 3.75, laborCost: 2.50 },
    'IEC_C13_cable_mount_female': { partCost: 3.25, laborCost: 2.50 },
    'IEC_C13_panel_mount_female': { partCost: 3.75, laborCost: 2.50 },
    'IEC-C13': { partCost: 3.00, laborCost: 2.50 },
    'IEC-C14': { partCost: 3.00, laborCost: 2.50 },
    
    // PowerCON Cable Mount Connectors
    'NAC3FXXA-W-S': { partCost: 10.25, laborCost: 2.50 },
    'NAC3FXXB-W-S': { partCost: 10.25, laborCost: 2.50 },
    'NAC3FXXA-W-S': { partCost: 10.25, laborCost: 2.50 },
    'NAC3FXXB-W-S': { partCost: 10.25, laborCost: 2.50 },
    'PowerCon_Grey_cable_mount_male': { partCost: 10.25, laborCost: 2.50 },
    // TRUE1 Cable Mount Connectors (updated pricing)
    'NAC3M-TRUE1-S': { partCost: 16.50, laborCost: 2.50 },
    'NAC3F-TRUE1-S': { partCost: 16.50, laborCost: 2.50 },
    // Legacy PowerCON entries (keep for backward compatibility)
    'NAC3MPXXA': { partCost: 12.50, laborCost: 2.50 },
    'PowerCon_Grey_panel_mount_female': { partCost: 12.50, laborCost: 2.50 },
    'NAC3FCA': { partCost: 4.25, laborCost: 2.50 },
    'NAC3FCB': { partCost: 4.25, laborCost: 2.50 },
    'NAC3M-TRUE1-S': { partCost: 4.50, laborCost: 2.50 },
    'NAC3F-TRUE1-S': { partCost: 4.25, laborCost: 2.50 },
    
    // DMX connectors
    'XLR3_F_DMX': { partCost: 2.75, laborCost: 2.50 },
    'XLR3_F_DMX_RA': { partCost: 3.50, laborCost: 2.50 },
    'XLR3_F_DMX_PANEL': { partCost: 3.75, laborCost: 2.50 },
    'XLR3_M_DMX': { partCost: 2.75, laborCost: 2.50 },
    'XLR3_M_DMX_RA': { partCost: 3.50, laborCost: 2.50 },
    'XLR3_M_DMX_PANEL': { partCost: 3.75, laborCost: 2.50 },
    'XLR5_F_DMX': { partCost: 3.50, laborCost: 2.50 },
    'XLR5_F_DMX_RA': { partCost: 4.25, laborCost: 2.50 },
    'XLR5_F_DMX_PANEL': { partCost: 4.50, laborCost: 2.50 },
    'XLR5_M_DMX': { partCost: 3.50, laborCost: 2.50 },
    'XLR5_M_DMX_RA': { partCost: 4.25, laborCost: 2.50 },
    'XLR5_M_DMX_PANEL': { partCost: 4.50, laborCost: 2.50 },
    
    // Other connectors
    'RJ45': { partCost: 2.00, laborCost: 2.50 },
    'NE8MX6': { partCost: 4.00, laborCost: 2.50 },
    'GEN-RJ45-M': { partCost: 1.50, laborCost: 2.50 },
    'BNC': { partCost: 2.75, laborCost: 2.50 },
    'BNC-RA': { partCost: 3.25, laborCost: 2.50 },
    'GEN-BNC-M': { partCost: 2.00, laborCost: 2.50 },
    'HDMI-A': { partCost: 2.50, laborCost: 2.50 },
    'HDMI-B': { partCost: 3.00, laborCost: 2.50 },
    'HDMI-C': { partCost: 2.75, laborCost: 2.50 },
    'USB-A': { partCost: 1.75, laborCost: 2.50 },
    'USB-B': { partCost: 2.00, laborCost: 2.50 },
    'USB-C': { partCost: 2.25, laborCost: 2.50 }
  },
  finishingPricing: {
    heatshrinkWrap: 1.00,
    customHeatShrinkPerEnd: 3,
    codingRings: 1.00
  },
  laborCost: 2.50,
  markups: {
    cable: 0.4, // 40% markup
    connectors: 0.3, // 30% markup
    finishing: 0.3, // 30% markup
    labor: 0.2 // 20% markup
  }
};

// Simple cache for pricing config to prevent unnecessary requests
let pricingConfigCache = null;
let cacheTimestamp = 0;
const CACHE_DURATION = 30000; // 30 seconds

export const loadPricingConfig = async () => {
  // Check if we have a valid cached version
  const now = Date.now();
  if (pricingConfigCache && (now - cacheTimestamp) < CACHE_DURATION) {
    console.log('DEBUG: Using cached pricing config');
    return pricingConfigCache;
  }

  try {
    const token = getAdminToken();
    const res = await fetch('/api/pricing-config', {
      headers: token ? { 'Authorization': `Bearer ${token}` } : {}
    });
    if (!res.ok) throw new Error('Failed to load pricing config');
    const config = await res.json();
    
    // Cache the result
    pricingConfigCache = config;
    cacheTimestamp = now;
    console.log('DEBUG: Loaded and cached pricing config');
    
    // Check if the config is empty and force upload default if needed
    const hasPricing = Object.keys(config.panelMountPricing || {}).length > 0 || 
                      Object.keys(config.inlinePricing || {}).length > 0;
    
    if (!hasPricing) {
      console.log('WARNING: Loaded config has no pricing data, forcing upload of default config...');
      try {
        const uploadRes = await fetch('/api/pricing-config', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(token ? { 'Authorization': `Bearer ${token}` } : {})
          },
          body: JSON.stringify({ action: 'forceUpload' })
        });
        
        if (uploadRes.ok) {
          console.log('SUCCESS: Default config uploaded to S3');
          // Reload the config after upload
          const reloadRes = await fetch('/api/pricing-config', {
            headers: token ? { 'Authorization': `Bearer ${token}` } : {}
          });
          if (reloadRes.ok) {
            return await reloadRes.json();
          }
        }
      } catch (uploadError) {
        console.error('ERROR: Failed to force upload default config:', uploadError);
      }
    }
    
    return config;
  } catch (error) {
    console.error('Error loading pricing configuration:', error);
    // Return default config if server is unavailable
    return defaultPricingConfig;
  }
};

export const savePricingConfig = async (config) => {
  try {
    const token = getAdminToken();
    const res = await fetch('/api/pricing-config', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { 'Authorization': `Bearer ${token}` } : {})
      },
      body: JSON.stringify({ ...config, lastUpdated: new Date().toISOString() })
    });
    if (!res.ok) throw new Error('Failed to save pricing config');
    
    // Clear cache after successful save
    pricingConfigCache = null;
    cacheTimestamp = 0;
    console.log('DEBUG: Cleared pricing config cache after save');
    
    return true;
  } catch (error) {
    console.error('Error saving pricing configuration:', error);
    return false;
  }
};

// All update functions should now be async and use await loadPricingConfig/savePricingConfig
export const updatePricingSection = async (section, data) => {
  const currentConfig = await loadPricingConfig();
  const updatedConfig = {
    ...currentConfig,
    [section]: {
      ...currentConfig[section],
      ...data
    }
  };
  return savePricingConfig(updatedConfig);
};

export const updateConnectorPricing = async (connector, pricing, isPanelMount = false) => {
  const currentConfig = await loadPricingConfig();
  const section = isPanelMount ? 'panelMountPricing' : 'inlinePricing';
  const updatedConfig = {
    ...currentConfig,
    [section]: {
      ...currentConfig[section],
      [connector]: pricing
    }
  };
  return savePricingConfig(updatedConfig);
};

export const updateCableBasePrices = async (cableType, price) => {
  const currentConfig = await loadPricingConfig();
  const updatedConfig = {
    ...currentConfig,
    cableBasePrices: {
      ...currentConfig.cableBasePrices,
      [cableType]: price
    }
  };
  return savePricingConfig(updatedConfig);
};

export const updatePowerWireGaugePricing = async (gauge, price) => {
  const currentConfig = await loadPricingConfig();
  const updatedConfig = {
    ...currentConfig,
    powerWireGaugePricing: {
      ...currentConfig.powerWireGaugePricing,
      [gauge]: price
    }
  };
  return savePricingConfig(updatedConfig);
};

export const updateWyeCablePricing = async (cableType, price) => {
  const currentConfig = await loadPricingConfig();
  const updatedConfig = {
    ...currentConfig,
    wyeCablePricing: {
      ...currentConfig.wyeCablePricing,
      [cableType]: price
    }
  };
  return savePricingConfig(updatedConfig);
};

export const updateFinishingPricing = async (option, price) => {
  const currentConfig = await loadPricingConfig();
  const updatedConfig = {
    ...currentConfig,
    finishingPricing: {
      ...currentConfig.finishingPricing,
      [option]: price
    }
  };
  return savePricingConfig(updatedConfig);
};

export const updateLaborCosts = async (quality, cost) => {
  const currentConfig = await loadPricingConfig();
  const updatedConfig = {
    ...currentConfig,
    laborCost: cost
  };
  return savePricingConfig(updatedConfig);
};

export const updateMarkups = async (category, markup) => {
  const currentConfig = await loadPricingConfig();
  const updatedConfig = {
    ...currentConfig,
    markups: {
      ...currentConfig.markups,
      [category]: markup
    }
  };
  return savePricingConfig(updatedConfig);
};

export const exportPricingConfig = async () => {
  const config = await loadPricingConfig();
  const blob = new Blob([JSON.stringify(config, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'pricingConfig.json';
  a.click();
};

export const importPricingConfig = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        const config = JSON.parse(e.target.result);
        await savePricingConfig(config);
        resolve();
      } catch (err) {
        reject(err);
      }
    };
    reader.onerror = reject;
    reader.readAsText(file);
  });
};

export const resetPricingConfig = async () => {
  return savePricingConfig(defaultPricingConfig);
};

export const getPricingHistory = async () => {
  // Not implemented for API version
  return [];
};

export const addPricingHistoryEntry = async (changes) => {
  // Not implemented for API version
  return false;
}; 